import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from 'pages/Authorization';

interface PrivateRouteProps {
  allowedTypes: string[];
  children?: React.ReactNode;
  path?: string | string[];
  exact?: boolean;
}

function PrivateRoute({ allowedTypes, children, ...rest }: PrivateRouteProps) {
  const { userType } = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }: any) =>
        userType && allowedTypes.includes(userType) ? (
          (children as React.ReactNode)
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
